<template>
    <el-container>
        <el-dialog :title="title" :visible.sync="addTeacher" :close-on-click-modal=false width="30%" :before-close="handleDialogClose">
            <el-form ref="form" :model="form" :rules="rulesList" label-width="120px" class="demo-ruleForm" align="left">
                <el-form-item label="教师姓名:" prop="teacherName">
                    <el-input v-model="form.teacherName" placeholder="教师姓名"></el-input>
                </el-form-item>
                <el-form-item label="教师资历:" prop="teacherZili"  >
                    <el-input v-model="form.teacherZili" placeholder="教师资历"></el-input>
                </el-form-item>
                <el-form-item label="主营类目:" prop="ccId" v-if="loginOrgCode != 'blcuonline'">
                    <el-select
                        v-model="form.ccId"
                        style="width: 100%"
                        multiple
                        clearable
                        placeholder="主营类目">
                        <el-option
                            v-for="item in eblucCourseData"
                            :key="item.ccId"
                            :label="item.ccName"
                            :value="item.ccId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属机构" prop="orgCode">
                    <el-select v-model="form.orgCode" placeholder="所属机构" @change="changeTeacherAdd" style="width: 100%">
                        <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="机构商品分类:" prop="orgCcId" v-if="showOrgCc && loginOrgCode != 'blcuonline'" >
                    <el-select
                        v-model="form.orgCcId"
                        style="width: 100%"
                        multiple
                        clearable
                        placeholder="机构商品分类">
                        <el-option
                            v-for="item in courseData"
                            :key="item.ccId"
                            :label="item.ccName"
                            :value="item.ccId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="讲授课程:" prop="teachCourse">
                    <el-input v-model="form.teachCourse" placeholder="讲授课程"></el-input>
                </el-form-item>
                <el-form-item label="教师简介:" prop="teacherJianjie">
                    <el-input type="textarea" :rows="3" v-model="form.teacherJianjie" placeholder="教师简介"></el-input>
                </el-form-item>
                <el-form-item label="教师头像:" prop="teacherHeader">
                    <el-upload
                        :action="uploadURL"
                        list-type="picture-card"
                        :on-remove="handleRemove"
                        :on-change="onChange"
                        :on-success="handleSuccess"
                        :before-upload="beforeAvatarUpload"
                        :limit="1"
                        :file-list="fileList"
                        :show-file-list="true"
                        :class="{'hide': hideUpload}"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="是否启用:">
                    <el-radio v-model="form.status" :label="1">启用</el-radio>
                    <el-radio v-model="form.status" :label="2">禁用</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleDialogClose">取 消</el-button>
                <el-button type="primary" @click="saveTeacher('form')">确 定</el-button>
            </div>
        </el-dialog>
        <el-main>
            <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
                <el-row>
                    <el-col :span="6" class="cls-col">
                        <el-form-item label="教师姓名" prop="teacherName" style="width: 70%">
                            <el-input v-model="searchData.teacherName" placeholder="教师姓名" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="状态" prop="status">
                            <el-select v-model="searchData.status" clearable placeholder="状态" size="small"
                                       style="width: 70%">
                                <el-option label="启用" :value="1"></el-option>
                                <el-option label="禁用" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="机构" prop="orgCode">
                            <el-select v-model="searchData.orgCode" clearable placeholder="机构" size="small"
                                       style="width: 70%">
                                <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
                </el-form-item>
            
            </el-form>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round
                       @click="addTeacher = true,title='新增教师'" class="but-cls">新增教师
            </el-button>
            <el-button type="success" icon="el-icon-circle-plus-outline" size="small" round @click="toRecommendTeacher"
                       class="but-cls" v-if="loginOrgCode != 'blcuonline'">首页名师推荐
            </el-button>
            <el-button type="danger" icon="el-icon-delete" size="small" round @click="deleteMore" class="but-cls">删除
            </el-button>
            <el-table
                :data="staffData"
                border
                highlight-current-row
                v-loading="loading"
                style="width: 100%"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    prop="teacherName"
                    label="教师姓名"
                    width="200"
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    prop="teacherZili"
                    label="教师资历"
                >
                </el-table-column>
                <el-table-column
                    prop="organizationName"
                    label="机构"
                >
                </el-table-column>
                <el-table-column
                    prop="status"
                    label="状态"
                    :formatter="teacherStatus"
                    width="80"
                >
                </el-table-column>
                <el-table-column
                    prop="sort"
                    label="排序"
                    width="80"
                    align="center"
                    v-if="loginOrgCode != 'blcuonline'"
                >
                    <template slot-scope="{row,$index}">
                        <input class="edit-cell" v-if="showEdit[row.teacherId]" v-model="row.sort">
                        <span v-if="!showEdit[row.teacherId]">{{row.sort}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="250"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleEdit(scope.$index, scope.row)" v-if="!showEdit[scope.row.teacherId] && loginOrgCode != 'blcuonline'"
                                   type="text" size="small"  >排序
                        </el-button>
                        <el-button @click="changeSort(scope.row)" v-if="showEdit[scope.row.teacherId]" type="text"
                                   size="small">更新
                        </el-button>
                        <el-button @click="updateTeacher(scope.$index, scope.row)" type="text" size="small">修改
                        </el-button>
                        <el-button @click="deleteTeacher(scope.$index, scope.row)" type="text" size="small">删除
                        </el-button>
                        <el-button @click="detail(scope.$index, scope.row)" type="text" size="small">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="pageSize"
                :current-page.sync="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                style="margin-top: 10px; float: right; margin-right: 10px">
            </el-pagination>
        </el-main>
    </el-container>
</template>

<script>
  import https from '@/https.js';

  const form = {
    teacherId: '',
    teacherName: '',
    teacherZili: '',
    teachCourse: '',
    orgCode: '',
    teacherJianjie: '',
    teacherHeader: '',
    ccId: [],
    ccOrgId: [],
    status: 1
  };
  export default {
    mounted() {
      window.Vue = this;
    },
    data() {
      return {
        loading: true,
        form: JSON.parse(JSON.stringify(form)),
        searchData: {
          orgCode: '',
          page: 1,
          size: 10,
          status: '',
          teacherId: '',
          teacherName: '',
          type: ''
        },
        multipleSelection: [],
        rules: {
          teacherName: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          teacherZili: [
            {required: true, message: '请输入资历', trigger: 'blur'},
            {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          ccId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          orgCcId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          teachCourse: [
            {required: true, message: '请输入讲授课程', trigger: 'blur'},
            {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          teacherJianjie: [
            {required: true, message: '请输入简介', trigger: 'blur'},
            {max: 2000, message: '长度不得超过2000个字符', trigger: 'blur'}
          ],
          orgCode: [
            {required: true, message: '请选择机构', trigger: 'blur'}
          ]
        },
        rules2: {
          teacherName: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          teacherZili: [
            {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          ccId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          orgCcId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          teachCourse: [
            {max: 50, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          teacherJianjie: [
            {max: 2000, message: '长度不得超过2000个字符', trigger: 'blur'}
          ],
          orgCode: [
            {required: true, message: '请选择机构', trigger: 'blur'}
          ]
        },
        total: 0,
        pageSize: 10,
        addTeacher: false,
        staffData: [],
        dialogImageUrl: '',
        dialogVisible: false,
        uploadURL: '',
        title: '新增教师',
        fileList: [],
        hideUpload: false,
        limitCount: 1,
        currentPage: 1,
        showEdit: [],
        org: [],
        courseData: [],
        eblucCourseData: [],
        showOrgCc: false
      };
    },
    methods: {
      changeSort(val) {
        const reg = /^\d{1,3}$/;
        if (!reg.test(val.sort)) {
          this.$message.error('最多输入3位数字');
          return;
        }
        this.updateSort(val);
      },
      toRecommendTeacher() {
        this.$router.push('/system/recommendTeacher');

      },
      handleEdit(index, row) {
        this.showEdit[row.teacherId] = true;
        this.search();
      },
      handleRemove(file, fileList) {
        this.form.teacherHeader = '';
        this.fileList = [];
        this.hideUpload = false;
      },
      onChange(file, fileList) {
        this.hideUpload = fileList.length >= this.limitCount;
      },
      handlePictureCardPreview(file) {
        this.dialogVisible = true;
        this.dialogImageUrl = file.url;
      },
      handleSuccess(response, file, fileList) {
        this.form.teacherHeader = response.data.filePath;
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 20;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      handleDialogClose() {
        this.form = JSON.parse(JSON.stringify(form));
        this.addTeacher = false;
        this.title = '新增教师';
        this.fileList = [];
        this.hideUpload = false;
        this.courseData = [];
        this.$refs['form'].clearValidate();
      },
      detail(index, row) {
        let url = https.teacherURL + '?teacherId=' + row.teacherId;
        window.open(url, '_blank');
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (let index in val) {
          this.multipleSelection[index] = val[index].teacherId;
        }
      },
      deleteMore() {
        let roleLength = this.multipleSelection.length;
        this.$confirm('此操作将删除' + roleLength + '条用户信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let multipleSelection = this.multipleSelection;
          let params = {
            teacherIdList: multipleSelection
          };
          https.fetchPost('/managerTeacher/deleteByTeacherIdList', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteTeacher(index, row) {
        this.$confirm('此操作将删除该用户信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            teacherIdList: [row.teacherId]
          };
          https.fetchPost('/managerTeacher/deleteByTeacherIdList', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.search();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败:' + msg
              });
            }
          }).catch(err => {
                this.$message.error('网络异常！');
              }
          );

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      search(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = this.pageSize;
        let params = this.searchData;
        this.loading = true;
        https.fetchPost('/managerTeacher/searchTeacher', params, 'json').then((data) => {
          let code = data.data.code;
          if (code == '200') {
            this.staffData = data.data.data.list;
            this.total = data.data.data.total;
            this.loading = false;
          }
        }).catch(err => {
              console.log(err);
              this.loading = false;
              this.$message.error('数据加载失败');
            }
        );
      },
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      updateTeacher(idnex, row) {
        this.addTeacher = true;
        console.log(new Date().getTime());
        this.form = JSON.parse(JSON.stringify(row));
        if (this.form.teacherHeader != '') {
          let file = {
            name: '123.png',
            url: this.form.teacherHeader
          };
          this.fileList.push(file);
        }
        this.hideUpload = this.fileList.length >= this.limitCount;
        console.log(new Date().getTime());
        this.title = '修改教师信息';
        this.loadCourseCategory();
        //this.courseData = [];
      },
      updateSort(row) {
        let params = row;
        https.fetchPost('/managerTeacher/updateSort', params).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.$message({
              message: '排序成功',
              type: 'success'
            });
            this.showEdit[row.teacherId] = false;
            this.search();
          } else {
            this.$message.error('操作失败:' + msg);
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      saveTeacher(formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            return false;
          } else {
            let url = '/managerTeacher/addTeacher';
            if (this.form.teacherId) {
              url = '/managerTeacher/updateTeacher';
            }
            let params = this.form;
            https.fetchPost(url, params).then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == '200') {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.hideUpload = false;
                this.addTeacher = false;
                this.search();
                this.form = JSON.parse(JSON.stringify(form));
                this.fileList = [];
                this.courseData = [];

              } else {
                this.$message.error('操作失败:' + msg);
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          }
        });
      },
      teacherStatus(row, column, cellValue, index) {
        if (cellValue == 1) { //（1 正常，2停用，3锁定）
          return '启用';
        }
        if (cellValue == 2) {
          return '禁用';
        }
        if (cellValue == 2) {
          return '锁定';
        }
        return '其他';
      },
      staffSex(row, column, cellValue, index) {
        if (cellValue == 1) { //（性别(0 未知；1女；2男)
          return '女';
        }
        if (cellValue == 2) {
          return '男';
        }

        return '未知';
      },
      selectOrg() {
        https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      changeTeacherAdd() {
        if (this.form.orgCode == this.$store.state.eblcuOrg) {
          this.showOrgCc = false;
          return;
        }
        this.showOrgCc = true;
        this.loadCourseCategory();
        this.courseData = [];
      },
      loadCourseCategory() {
        let params = {
          orgCode: this.form.orgCode
        };
        https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if (data.data.data) {
              this.courseData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      },
      loadBlcuCourseCategory() {
        let params = {
          orgCode: this.$store.state.eblcuOrg
        };
        https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            if (data.data.data) {
              this.eblucCourseData = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
            }
        );
      }
    },

    computed: {
      rulesList: function() {
        if (this.loginOrgCode != 'blcuonline') {
          return this.rules
        } else {
          return this.rules2
        }
      },
    },
    created: function() {
      this.loginOrgCode = this.$store.state.orgCode;
      this.search();
      this.selectOrg();
      this.loadBlcuCourseCategory();
      this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
    }
  };
</script>

<style>
    .but-cls {
        margin-bottom: 10px;
    }
    
    .cls-col {
        margin-right: 20px;
    }
    
    .hide .el-upload--picture-card {
        display: none;
    }
    
    .edit-cell {
        width: 60%;
    }
</style>
